// A deliberate sign-out (manual, or the idle timeout) invalidates the token on the server before the
// browser has dropped it, so requests still in flight or polling at that moment come back 401. Those
// are not an "expired session" the user needs to be warned about. The token being signed out is kept
// here so ApiCall can tell them apart; a new login has a new token, so it needs no reset.
let signedOutToken = null;

export const markSigningOut = (token) => {
  signedOutToken = token || null;
};

export const isSigningOut = (token) => !token || (signedOutToken !== null && token === signedOutToken);
